import NAME from "./constants";

export const GET_MY_ANNOTATION_ROWS = NAME + "/GET_MY_ANNOTATION_ROWS";
export const GET_MY_ANNOTATION_ROWS_FULFILLED = NAME + "/GET_MY_ANNOTATION_ROWS_FULFILLED";
export const GET_MY_ANNOTATION_ROWS_REJECTED = NAME + "/GET_MY_ANNOTATION_ROWS_REJECTED";
